import { motion } from 'framer-motion'
import { redirectToRestaurants } from '../../config/navigation'

export default function CTASection() {
  return (
    <section
      id="cta"
      className="bg-gradient-to-br from-[#e8cc45] via-[#f5d96b] to-[#ffe89e] py-24 px-4 text-center"
    >
      <motion.div
        className="max-w-2xl mx-auto"
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <h2 className="text-[clamp(2rem,4vw,3.2rem)] font-black tracking-[-0.03em] text-neutral-900 mb-4">
          Ready to order?
        </h2>
        <p className="text-base text-black/55 mb-10 leading-relaxed max-w-md mx-auto">
          Jump straight into the portal and browse restaurants near you. Your next great meal is a few clicks away.
        </p>
        <motion.button
          whileHover={{ y: -2, boxShadow: '0 8px 28px rgba(0,0,0,0.22)' }}
          whileTap={{ scale: 0.98 }}
          onClick={() => redirectToRestaurants()}
          className="inline-flex items-center gap-2.5 bg-neutral-900 text-white px-10 py-4 rounded-[14px] text-[1.05rem] font-bold shadow-lg transition-shadow"
        >
          <svg className="w-[18px] h-[18px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M6 2 3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
            <line x1="3" y1="6" x2="21" y2="6"/>
            <path d="M16 10a4 4 0 01-8 0"/>
          </svg>
          Order Now
        </motion.button>
      </motion.div>
    </section>
  )
}
